import { render, staticRenderFns } from "./UMLClassElement.vue?vue&type=template&id=16357b46&scoped=true&"
import script from "./UMLClassElement.vue?vue&type=script&lang=js&"
export * from "./UMLClassElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16357b46",
  null
  
)

export default component.exports